import React from "react";
import history from "../utils/history";

export default (): JSX.Element => {
    return (
        <div className="intro-content">
            <h2>Play Keno!</h2>
            <p>Pick your own numbers or use Quick Pick.</p>
            <p>Choose from 1 to 10 numbers, match and win!</p>
            <p>A new draw every 5 minutes.</p>
            <p>
                <button
                    className="styled-button"
                    type="button"
                    onClick={ (): void => history.push("/purchase/") }
                >Play Keno</button>
            </p>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/ContentSidebar.tsx